import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
//primereact
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { Checkbox } from "primereact/checkbox";
import { DataTable } from "primereact/datatable";
//services
import { getUserOpenPayments } from "../../../services/ClientArea/getUserOpenPayments";
//context
import { useAppContext } from "../../../context/AppContext";
import { useUserRegistrationContext } from "../UserRegistrationContext";
//utils
import { formatDate } from "../../../utils/formatDate";
import { formatCurrency } from "../../../utils/formatCurrency";
//services
import ModalOpenPayments from "./ModalOpenPayments";

const UserOpenPayments = () => {
  const { permissions } = useAppContext();
  const { itemsSelected, setItemsSelected, visible, setVisible } = useUserRegistrationContext();
  const [selectAll, setSelectAll] = useState(false);

  const isRowSelected = (rowData) => {
    return itemsSelected.some((row) => row.id === rowData.id);
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    if (newSelectAll) {
      setItemsSelected(data);
    } else {
      const overduePayments = [];
      data.map((payment) => {
        if (payment.overdue) {
          overduePayments.push(payment);
        }
        return null;
      });
      if (overduePayments.length === data.length) {
        setSelectAll(true);
      }
      setItemsSelected(overduePayments);
    }
  };

  const handleRowSelect = (rowData) => {
    const isSelected = isRowSelected(rowData);
    let updatedSelectedRows = [...itemsSelected];
  
    if (isSelected) {
      updatedSelectedRows = updatedSelectedRows.filter(
        (row) => new Date(row.due_date) < new Date(rowData.due_date)
      );
    } else {
      const previousPayments = data.filter(
        (payment) =>
          new Date(payment.due_date) <= new Date(rowData.due_date) &&
          !updatedSelectedRows.some((row) => row.id === payment.id)
      );
  
      updatedSelectedRows = [...updatedSelectedRows, ...previousPayments];
    }
  
    setSelectAll(updatedSelectedRows.length === data.length);
    setItemsSelected(updatedSelectedRows);
  };
  
  
  const { data, isLoading } = useQuery({
    queryKey: ["UserOpenPayments"],
    queryFn: () => getUserOpenPayments(),
    retry: false,
    enabled: !!permissions?.includes("1"),
  });

  const sortedData = data ? [...data].sort(
    (a, b) => new Date(a.due_date) - new Date(b.due_date)
  ) : [];

  const columns = [
    { field: "id", header: "Fatura" },
    {
      field: "desc",
      header: "Descrição",
    },
    {
      field: "status",
      header: "Status",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 0:
            if (rowData.overdue) {
              labelClass = "badge bg-danger";
              labelText = "Em Atraso";
            } else {
              labelClass = "badge bg-warning";
              labelText = "Pendente";
            }
            break;
          case 1:
            labelClass = "badge bg-success";
            labelText = "Pago";
            break;
          case 2:
            if (rowData.overdue) {
              labelClass = "badge bg-danger";
              labelText = "Em Atraso";
            } else {
              labelClass = "badge bg-warning";
              labelText = "Pendente";
            }
            break;
          default:
        }
        return (
          <span
            className={labelClass}
            style={{
              fontSize: "14px",
              marginLeft: "5px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
    {
      field: "value",
      header: "Valor Atualizado",
      body: (rowData) => {
        if(rowData.overdue){
          return formatCurrency(parseFloat(rowData.total_due));
        } else{
          return formatCurrency(rowData.value);
        }
      },
    },
    {
      field: "due_Date",
      header: "Vencimento",
      body: (rowData) => {
        return formatDate(rowData.due_date);
      },
    },
  ];

  useEffect(() => {
    if (data) {
      const overduePayments = [];
      data.map((payment) => {
        if (payment.overdue) {
          overduePayments.push(payment);
        }
        return null;
      });
      if (overduePayments.length === data.length) {
        setSelectAll(true);
      }
      if (itemsSelected.length === 0) setItemsSelected(overduePayments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <>
      <div className="row pb-4">
        {isLoading ? (
          <Skeleton width="100%" height={400} />
        ) : (
          <>
            {data && (
              <>
                <div className="row justify-content-end mb-3">
                  <div className="col-xl-3 col-md-8">
                    <Button
                      rounded
                      label="Pagar Selecionadas"
                      className="w-100"
                      icon="fa-solid fa-money-bill-wave"
                      onClick={() => setVisible(true)}
                      disabled={itemsSelected.length === 0}
                    />
                  </div>
                </div>
                <DataTable
                  rows={5}
                  paginator
                  stripedRows
                  showGridlines
                  sortMode="multiple"
                  selectionMode="single"
                  rowsPerPageOptions={[5, 25, 100]}
                  value={sortedData}
                  emptyMessage="Nenhuma Informação foi encontrada."
                  tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                >
                  <Column
                    field="check_id"
                    header={
                      <Checkbox
                        onChange={handleSelectAll}
                        checked={selectAll}
                      />
                    }
                    body={(rowData) => {
                      // Lógica para renderizar checkboxes
                      if (rowData.overdue) {
                        return (
                          <Checkbox
                            disabled
                            checked={true}
                            onChange={() => handleRowSelect(rowData)}
                          />
                        );
                      } else {
                        return (
                          <Checkbox
                            checked={itemsSelected.some(
                              (row) => row.id === rowData.id
                            )}
                            onChange={() => handleRowSelect(rowData)}
                          />
                        );
                      }
                      // } else if (rowData.ableToPay) {
                      //   return (
                      //     <Checkbox
                      //       checked={itemsSelected.some(
                      //         (row) => row.id === rowData.id
                      //       )}
                      //       onChange={() => handleRowSelect(rowData)}
                      //     />
                      //   );
                      // } else {
                      //   return null;
                      // }
                    }}
                  />
                  {columns.map((col) => (
                    <Column
                      sortable
                      key={col.field}
                      field={col.field}
                      header={col.header}
                      editor={col.editor}
                      body={col.body}
                    />
                  ))}
                </DataTable>
              </>
            )}
          </>
        )}
      </div>

      <ModalOpenPayments visible={visible} setVisible={setVisible} />
    </>
  );
};

export default UserOpenPayments;
